/** @format */

import {Box, styled, Typography} from '@mui/material';

import SecondaryMediumButton from 'components/buttons/SecondaryMediumButton';

export const Title = styled(Typography)(({theme}) => ({
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '30px',
  letterSpacing: '0.225px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: theme.spacing(6, 0, 4, 0),
}));

export const RecommendationContainer = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(3),
}));

export const RecommendationGrid = styled(Box)(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: theme.spacing(1),
  overflow: 'hidden',
  borderRadius: '8px',
  marginTop: theme.spacing(2),
  '& > :last-of-type:nth-of-type(odd)': {
    gridColumn: '1 / -1',
  },
}));

export const ReportButton = styled(SecondaryMediumButton)(({theme}) => ({
  padding: theme.spacing(4, 8),
  borderRadius: '8px',
  background: theme.palette.semantic_dark?.surface.surface1,
  boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  '&:hover': {
    background: theme.palette.figma_gray_dark_2?.main,
  },
}));
